import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";

export default function SubsidiaryCard({
  title,
  tag,
  description,
  image,
  url = "#",
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`subsidiary-card ${visible ? "visible" : ""}`}>
      <div className="subsidiary-image">
        <img src={image} alt={title} />
      </div>
      <div className="subsidiary-overlay">
        <div className="subsidiary-tag">{tag}</div>
        <div className="subsidiary-title">{title}</div>
        <div className="subsidiary-description">{description}</div>
        {url &&
          (url.startsWith("http") ? (
            <a
              className="subsidiary-link"
              href={url}
              target="_blank"
              rel="noopener"
            >
              Learn More <ArrowRight size={14} />
            </a>
          ) : (
            <a className="subsidiary-link" href={url}>
              Learn More <ArrowRight size={14} />
            </a>
          ))}
      </div>
    </div>
  );
}
